module.exports = __webpack_public_path__ + "img/ii-logo.7cc55572.gif";